import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig).catch(err => {
  console.error('App Boot Error:', err);
});


// Register service worker only for web platform (not native)
import { Capacitor } from '@capacitor/core';

if ('serviceWorker' in navigator && !Capacitor.isNativePlatform()) {
  navigator.serviceWorker
    .register('firebase-messaging-sw.js')
    .then((registration) => {
      // Service worker registered
    })
    .catch((err) => {
      console.error('Firebase SW registration failed:', err);
    });
} else if (Capacitor.isNativePlatform()) {
  // Native platform detected - skipping service worker registration
}
